import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { formatSinceTime } from '@helpers';
import { scale } from '@components/frame';

import { font } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import Svg from '@styles/icons/svg';
import { DownloadBlock } from './noConnector';

const ConnectorOff = ({ C, time }) => {
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', flex: 1, backgroundColor: C('Background/Light/Detail') }}>
      <View style={{ alignItems: 'center', width: scale(330) }}>
        <View style={{ alignItems: 'center' }}>
          <Text style={[font['Large Title'], { color: C('Label/Light/Primary') }]}>{i18n.t('Connector Offline')}</Text>
          {time && (
            <Text style={[font['Body Extra Large'], { color: C('Label/Light/Primary'), marginTop: scale(4) }]}>
              {i18n.t('Since')} {formatSinceTime(time)}
            </Text>
          )}
        </View>
        <View style={{ marginTop: scale(36) }}>
          <Svg icon="connectorOfflineLarge" width={scale(180)} height={scale(120)} color="Label/Light/Error" />
        </View>
        <DownloadBlock {...{ C }} />
      </View>
    </View>
  );
};

export default ColorWrapper(ConnectorOff);
